import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import s from './styles.module.scss';

const PrivacyPolicyText = ({ scroll, t }) => (
  <div className={cx(s.content, scroll ? s.scroll : '')}>
    <h2>{t('privacyPolicy.purpose.title')}</h2>
    <p>{t('privacyPolicy.purpose.paragraph1')}</p>
    <p>{t('privacyPolicy.purpose.paragraph2')}</p>
    <h2>{t('privacyPolicy.cannetVirtuesAndConsent.title')}</h2>
    <p>
      {t('privacyPolicy.cannetVirtuesAndConsent.paragraph1Part1')}
      <a href={t('privacyPolicy.cannetVirtuesAndConsent.paragraph1LinkValue1')}>
        {t('privacyPolicy.cannetVirtuesAndConsent.paragraph1Link1')}
      </a>
      {t('privacyPolicy.cannetVirtuesAndConsent.paragraph1Part2')}
    </p>
    <p>
      {t('privacyPolicy.cannetVirtuesAndConsent.paragraph2Part1')}
      <a href={t('privacyPolicy.cannetVirtuesAndConsent.paragraph2LinkValue1')}>
        {t('privacyPolicy.cannetVirtuesAndConsent.paragraph2Link1')}
      </a>
      {t('privacyPolicy.cannetVirtuesAndConsent.paragraph2Part2')}
    </p>
    <h2>{t('privacyPolicy.colliectionOfPersonalHealthInfo.title')}</h2>
    <p>{t('privacyPolicy.colliectionOfPersonalHealthInfo.paragraph1')}</p>
    <ul className={s.ul}>
      <li>{t('privacyPolicy.colliectionOfPersonalHealthInfo.li1')}</li>
      <li>{t('privacyPolicy.colliectionOfPersonalHealthInfo.li2')}</li>
      <li>{t('privacyPolicy.colliectionOfPersonalHealthInfo.li3')}</li>
      <li>{t('privacyPolicy.colliectionOfPersonalHealthInfo.li4')}</li>
    </ul>
    <h2>{t('privacyPolicy.limitingCollection.title')}</h2>
    <p>{t('privacyPolicy.limitingCollection.paragraph1')}</p>
    <h2>{t('privacyPolicy.ensuringAccuracy.title')}</h2>
    <p>{t('privacyPolicy.ensuringAccuracy.paragraph1')}</p>
    <h2>{t('privacyPolicy.ensuringSafeguards.title')}</h2>
    <p>{t('privacyPolicy.ensuringSafeguards.paragraph1')}</p>
    <h2>{t('privacyPolicy.updatesToThisPrivacyPolicy.title')}</h2>
    <p>{t('privacyPolicy.updatesToThisPrivacyPolicy.paragraph1')}</p>
    <h2>{t('privacyPolicy.privacyOfficer.title')}</h2>
    <p>{t('privacyPolicy.privacyOfficer.paragraph1')}</p>
    <div>{t('privacyPolicy.privacyOfficer.p1')}</div>
    <div>{t('privacyPolicy.privacyOfficer.p2')}</div>
    <div>{t('privacyPolicy.privacyOfficer.p3')}</div>
    <div>{t('privacyPolicy.privacyOfficer.p4')}</div>

    <h2 className={s.definitions}>{t('privacyPolicy.definitions')}</h2>
    <h3>{t('privacyPolicy.healthInformationCustodian.title')}</h3>
    <p>
      {t('privacyPolicy.healthInformationCustodian.paragraph1Part1')}
      <a href={t('privacyPolicy.healthInformationCustodian.paragraph1LinkValue1')}>
        {t('privacyPolicy.healthInformationCustodian.paragraph1Link1')}
      </a>
      {t('privacyPolicy.healthInformationCustodian.paragraph1Part2')}
    </p>
    <h3>{t('privacyPolicy.patientOrPatientUser.title')}</h3>
    <p>{t('privacyPolicy.patientOrPatientUser.paragraph1')}</p>

    <h3>{t('privacyPolicy.personalHealthInfo.title')}</h3>
    <p>{t('privacyPolicy.personalHealthInfo.paragraph1')}</p>
    <ul className={s.ul}>
      <li>{t('privacyPolicy.personalHealthInfo.li1')}</li>
      <li>{t('privacyPolicy.personalHealthInfo.li2')}</li>
      <li>{t('privacyPolicy.personalHealthInfo.li3')}</li>
      <li>{t('privacyPolicy.personalHealthInfo.li4')}</li>
      <li>{t('privacyPolicy.personalHealthInfo.li5')}</li>
      <li>{t('privacyPolicy.personalHealthInfo.li6')}</li>
      <li>{t('privacyPolicy.personalHealthInfo.li7')}</li>
    </ul>

    <h3>{t('privacyPolicy.personalInfo.title')}</h3>
    <p>{t('privacyPolicy.personalInfo.paragraph1')}</p>
    <ul className={s.ul}>
      <li>{t('privacyPolicy.personalInfo.li1')}</li>
      <li>{t('privacyPolicy.personalInfo.li2')}</li>
      <li>{t('privacyPolicy.personalInfo.li3')}</li>
      <li>{t('privacyPolicy.personalInfo.li4')}</li>
      <li>{t('privacyPolicy.personalInfo.li5')}</li>
      <li>{t('privacyPolicy.personalInfo.li6')}</li>
      <li>{t('privacyPolicy.personalInfo.li7')}</li>
      <li>{t('privacyPolicy.personalInfo.li8')}</li>
    </ul>
    <p className={s.marginTop}>{t('privacyPolicy.personalInfo.paragraph2')}</p>
    <ul className={s.ul}>
      <li>{t('privacyPolicy.personalInfo.li9')}</li>
      <li>{t('privacyPolicy.personalInfo.li10')}</li>
    </ul>

    <h3>{t('privacyPolicy.researchParticipant.title')}</h3>
    <p>{t('privacyPolicy.researchParticipant.paragraph1')}</p>

    <h3>{t('privacyPolicy.networkInvestigator.title')}</h3>
    <p>{t('privacyPolicy.networkInvestigator.paragraph1')}</p>
    <ul className={s.ul}>
      <li>{t('privacyPolicy.networkInvestigator.li1')}</li>
    </ul>

    <h3>{t('privacyPolicy.networkMembers.title')}</h3>
    <p>{t('privacyPolicy.networkMembers.paragraph1')}</p>

    <h3>{t('privacyPolicy.theCanet.title')}</h3>
    <p>{t('privacyPolicy.theCanet.paragraph1')}</p>
  </div>
);

PrivacyPolicyText.defaultProps = {
  scroll: true,
};

PrivacyPolicyText.propTypes = {
  scroll: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PrivacyPolicyText);
